<template>
    <a-modal v-model="visible" :title="title" :footer="null" width="80%" :closable="false" :keyboard="false" :maskClosable="false">
        <a-spin :spinning="loading">
            <div class="contract-box" v-html="artcCntnt">
            </div>
            <div class="spaceCenter">
                <a-button type="primary" style="margin:30px 5px;width:90px;" @click="okModal()">签署</a-button>
            </div>
        </a-spin>
    </a-modal>
</template>
<script>
/**
 * 初次登录签署协议弹窗
 */
import {protocolList,signatureSave} from "@/api/lawTxt.js"
export default {
    props:["title","fileId"],
    name:"userService",
    data() {
        return {
            visible:false,
            loading:false,
            artcCntnt:"",
            lawValue:{}
        };
    },
    computed: {},
    methods: {
        open(){
            this.visible = true;
        },
        close(){
            this.visible = false;
        },
        okModal(){
            this.loading = true;
            const params = { ...this.lawValue };
            delete params['artcCntnt'];
            signatureSave(params,true)
            .then(res => {
                this.$message.success("签署成功！");
                this.loading = false;
                this.$emit("ok");
                this.close();
            })
            .catch(err => {
                this.loading = false;
                console.log(err);
            })
        },
        borrowedContractList(){
            this.loading = true;
            let params;
            if(this.fileId) {
                  params = {
                fileId:this.fileId
            };
            protocolList(params)
            .then(res => {
                this.lawValue = res.data;
                this.artcCntnt = res.data.artcCntnt;
                this.loading = false;
            })
            .catch(err => {
                console.log(err);
                this.loading = false;
            })
            }
          
        },
    },
    watch:{
        fileId(newVal){
            this.borrowedContractList();
        }
    }
}
</script>
<style scoped>
.contract-box{
    width: 86%;
    min-height: 60vh;
    margin:0 auto;
    border: #e9ebee 1px solid;
    margin-top: 30px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/components/sign/user-service.vue